import Request from '../../request';
const BASE_URI_GO_API = process.env.API_GO_URL + '/api/v1';

const GetListagemSolicitacoesProcesso = async(pagina) => {
    try{

        let quantidade = 10;

        return await Request.AxiosAuthGet(`${BASE_URI_GO_API}/central-cobranca/lista/${quantidade}/${pagina}`);

    } catch(error) {
        throw new Error(`Erro ao carregar listagem das solicitações`);
    }
}
const GetTotalSolicitacoesProcesso = async() => {
    try{
        return await Request.AxiosAuthGet(`${BASE_URI_GO_API}/central-cobranca/total`);

    } catch(error) {
        throw new Error(`Erro ao carregar total dos status de solicitações`);
    }
}
const GetDetalheSolicitacaoProcesso = async(solicitacaoID) => {
    try{
        return await Request.AxiosAuthGet(`${BASE_URI_GO_API}/central-cobranca/detalhe/solicitacao/${solicitacaoID}`);

    } catch(error) {
        throw new Error(`Erro ao carregar detalhe da solicitação`);
    }
}
const GetDetalheNotificacoesProcesso = async(solicitacaoID) => {
    try{
        return await Request.AxiosAuthGet(`${BASE_URI_GO_API}/central-cobranca/detalhe/notificacoes/${solicitacaoID}`);

    } catch(error) {
        throw new Error(`Erro ao carregar detalhe das notificações`);
    }
}

const GetListagemSolicitacoesProcessoFiltro = async(pagina, status) => {
    try{

        let quantidade = 10;

        return await Request.AxiosAuthGet(`${BASE_URI_GO_API}/central-cobranca/lista/${quantidade}/${pagina}/${status}`);

    } catch(error) {
        throw new Error(`Erro ao carregar listagem das solicitações`);
    }
}

export default {GetListagemSolicitacoesProcesso, GetTotalSolicitacoesProcesso, GetDetalheSolicitacaoProcesso, GetDetalheNotificacoesProcesso, GetListagemSolicitacoesProcessoFiltro}




// WEBPACK FOOTER //
// ./src/services/api/centralCobranca/index.js